import { memo } from 'react';
import { Autocomplete, AutocompleteItem } from '@heroui/react';

const AutoComplete = memo(function AutoComplete({
  title,
  name,
  data,
  placeholder,
  required,
  value,
  errors,
  touched,
  setFieldValue,
}) {
  return (
    <div className="flex flex-col items-start justify-end gap-2.5 w-full relative">
      <div className="flex flex-row items-center gap-1 w-full h-6">
        <p className="text-text-normal text-base font-semibold">{title}</p>
        {/* {required && <p className="text-error text-sm">اجباری</p>} */}
      </div>
      <div className="flex w-full flex-wrap md:flex-nowrap gap-4 h-[54px]">
        <Autocomplete
          showScrollIndicators={true}
          defaultSelectedKey={value}
          value={value}
          name={name}
          onSelectionChange={(e) => setFieldValue(name, e)}
          inputProps={{
            classNames: {
              mainWrapper: 'group-data-[hover=true]:bg-white group-data-[focus=true]:bg-white',
              input: 'group-data-[hover=true]:bg-white group-data-[focus=true]:bg-white',
              inputWrapper: `h-[54px] bg-white shadow-none ${
                errors && touched ? 'border-error' : 'border-light-grey'
              } border-1 rounded-lg group-data-[hover=true]:bg-white group-data-[focus=true]:bg-white transition-all`,
            },
          }}
          classNames={{
            value: [
              'text-base',
              'text-text-normal/70',
              'font-light',
              'group-data-[has-value=true]:text-text-hard',
              'group-data-[has-value=true]:font-normal',
            ],
            popoverContent: 'p-0 rounded-lg border-1 border-light-grey',
            listbox: 'p-2',
            listboxWrapper: 'p-1',
          }}
          className="custom-select"
          listboxProps={{
            emptyContent: 'موردی یافت نشد',
            style: {
              overflowY: 'scroll',
              maxHeight: '250px',
            },
            itemClasses: {
              base: [
                // "transition-colors",

                // "data-[hover=true]:text-foreground",
                'data-[hover=true]:bg-gray',
                'data-[selectable=true]:focus:bg-gray',
                'data-[selected=true]:text-primary',
                'data-[selected=true]:focus:text-primary',
                'data-[pressed=true]:opacity-100',
                'data-[focus=true]:bg-primary',
                // "data-[focus-visible=true]:ring-gray",
                // "hover:bg-gray",
                // "focus:bg-gray"
              ],
            },
          }}
          placeholder={placeholder}
        >
          {name == 'province' ? (
            data.map((item) => (
              <AutocompleteItem key={item.province} textValue={item.province}>
                <div className="flex flex-col items-start p-1">
                  <p className="text-base">{item.province}</p>
                  {/* <span
                  className={`truncate flex flex-row items-center gap-2 w-full whitespace-break-spaces font-light text-xs line-clamp-1`}
                >
                  {item.description}
                </span> */}
                </div>
              </AutocompleteItem>
            ))
          ) : !data ? (
            <AutocompleteItem>
              <div className="flex flex-col items-start p-1">
                <p className="text-base">استان خود را انتخاب کنید</p>
                {/* <span
            className={`truncate flex flex-row items-center gap-2 w-full whitespace-break-spaces font-light text-xs line-clamp-1`}
          >
            {item.description}
          </span> */}
              </div>
            </AutocompleteItem>
          ) : (
            data.map((item) => (
              <AutocompleteItem key={item} textValue={item}>
                <div className="flex flex-col items-start p-1">
                  <p className="text-base">{item}</p>
                  {/* <span
                  className={`truncate flex flex-row items-center gap-2 w-full whitespace-break-spaces font-light text-xs line-clamp-1`}
                >
                  {item.description}
                </span> */}
                </div>
              </AutocompleteItem>
            ))
          )}
        </Autocomplete>
      </div>
      {errors && touched && <p className="absolute -bottom-6 text-xs text-error">{errors}</p>}
    </div>
  );
});

export default AutoComplete;
